import { Reveal, MaskedHeading } from "../Reveal";
import { PACT } from "../../data/content";

export default function Pact() {
  return (
    <section className="section bg-marine py-24 md:py-40 relative" data-testid="pact-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <span className="chapter-num">CHAPITRE 07 — LE PACTE</span>

        <div className="mt-8 max-w-4xl">
          <MaskedHeading
            tag="h2"
            className="font-display font-medium text-[clamp(2.4rem,5.2vw,4.6rem)] leading-[1.02] tracking-tight text-pearl"
            lines={["La Traversée est offerte."]}
          />
          <MaskedHeading
            tag="p"
            delay={0.15}
            className="font-display italic text-[clamp(1.5rem,3.4vw,2.6rem)] leading-tight text-aqua mt-3"
            lines={["Mais elle n'est pas conçue", "pour être consommée passivement."]}
          />
        </div>

        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mt-14">
          <Reveal className="lg:col-span-5 space-y-4 text-pearl/75 text-lg leading-relaxed">
            <p>Tu peux t'inscrire gratuitement.</p>
            <p>Tu peux regarder les replays.</p>
            <p>Tu peux avancer à ton rythme.</p>
            <p>
              Mais cette expérience aura d'autant plus de sens si tu acceptes de lui offrir
              quelque chose que l'on ne peut ni acheter ni automatiser : ta présence.
            </p>
            <p className="text-aqua">
              Le Pacte de Traversée n'est pas une promesse de résultat. C'est un engagement
              envers toi-même.
            </p>
          </Reveal>

          <div className="lg:col-span-7">
            <p className="eyebrow text-pearl/50 mb-6">EN REJOIGNANT LA TRAVERSÉE, TU ES INVITÉ À</p>
            <ul className="space-y-0">
              {PACT.map((item, i) => (
                <Reveal
                  key={i}
                  delay={i * 0.06}
                  as="li"
                  className="flex gap-6 items-start py-5 border-t border-pearl/12"
                >
                  <span className="font-display text-2xl text-gold leading-none w-8 shrink-0">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-pearl/85 text-lg leading-snug">{item}</span>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>

        <Reveal delay={0.1} className="mt-16 max-w-3xl">
          <p className="font-display text-2xl md:text-3xl leading-snug text-pearl">
            Tu n'as pas besoin d'être prêt à tout changer. Tu as seulement besoin d'être
            disposé à rencontrer ce qui pourrait commencer.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
